<div class="modal-header">
  <h4 class="modal-title">{{ 'main.tabBar.view.label.move_coordinate_center_short' | translate }}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <div class="d-flex flex-column gap-2 pt-2">
      <div class="d-flex align-items-center gap-2">
        <label class="col-2 mb-0" for="translation-x">{{ 'moveCoordinateCenter.label.x' | translate }}</label>
        <input id="translation-x" class="form-control" type="number" step="0.1" [(ngModel)]="translationX" />
      </div>
      <div class="d-flex align-items-center gap-2">
        <label class="col-2 mb-0" for="translation-y">{{ 'moveCoordinateCenter.label.y' | translate }}</label>
        <input id="translation-y" class="form-control" type="number" step="0.1" [(ngModel)]="translationY" />
      </div>
      <div class="d-flex align-items-center gap-2">
        <label class="col-2 mb-0" for="translation-z">{{ 'moveCoordinateCenter.label.z' | translate }}</label>
        <input id="translation-z" class="form-control" type="number" step="0.1" [(ngModel)]="translationZ" />
      </div>
      <div class="d-flex align-items-center gap-2">
        <label class="col-2 mb-0" for="rotation-x">{{ 'moveCoordinateCenter.label.rotation_x' | translate }}</label>
        <input id="rotation-x" class="form-control" type="number" step="0.1" [(ngModel)]="rotationX" />
      </div>
      <div class="d-flex align-items-center gap-2">
        <label class="col-2 mb-0" for="rotation-y">{{ 'moveCoordinateCenter.label.rotation_y' | translate }}</label>
        <input id="rotation-y" class="form-control" type="number" step="0.1" [(ngModel)]="rotationY" />
      </div>
      <div class="d-flex align-items-center gap-2">
        <label class="col-2 mb-0" for="rotation-z">{{ 'moveCoordinateCenter.label.rotation_z' | translate }}</label>
        <input id="rotation-z" class="form-control" type="number" step="0.1" [(ngModel)]="rotationZ" />
      </div>
    </div>
  </div>
</div>
<div class="modal-footer d-flex flex-column">
  <div class="d-flex flex-row">
    <button class="btn btn-secondary btn-cancel mx-1" (click)="cancel()">
      {{'global.label.cancel' | translate}}
    </button>
    <button class="btn btn-primary mx-1" (click)="moveCoordinateCenter()">
      {{ 'global.label.ok' | translate }}
    </button>
  </div>
</div>
